import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initAiParticles(containerId: string): void {
    const container = document.getElementById(containerId);
    if (!container) return;

    const canvas = document.createElement('canvas');
    container.appendChild(canvas);
    const ctx = canvas.getContext('2d')!;

    let width = 0;
    let height = 0;
    const particles: Particle[] = [];
    const particleCount = 120;

    class Particle {
        x: number = Math.random() * width;
        y: number = Math.random() * height;
        vx: number = (Math.random() - 0.5) * 0.4;
        vy: number = (Math.random() - 0.5) * 0.4;
        size: number = Math.random() * 2 + 0.5;
        pulse: number = Math.random() * Math.PI;

        update() {
            this.x += this.vx;
            this.y += this.vy;
            this.pulse += 0.05;

            if (this.x < 0 || this.x > width) this.vx *= -1;
            if (this.y < 0 || this.y > height) this.vy *= -1;
        }

        draw() {
            const opacity = 0.2 + Math.sin(this.pulse) * 0.3;
            ctx.fillStyle = `rgba(0, 242, 255, ${opacity})`;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fill();
        }
    }

    function resize() {
        width = canvas.width = container!.clientWidth;
        height = canvas.height = container!.clientHeight;
    }

    function init() {
        resize();
        particles.length = 0;
        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }
    }

    function animate() {
        ctx.clearRect(0, 0, width, height);
        
        particles.forEach((p, i) => {
            p.update();
            p.draw();

            for (let j = i + 1; j < particles.length; j++) {
                const p2 = particles[j];
                const dx = p.x - p2.x;
                const dy = p.y - p2.y;
                const dist = Math.hypot(dx, dy);

                if (dist < 120) {
                    const alpha = (1 - dist / 120) * 0.4;
                    ctx.strokeStyle = `rgba(0, 242, 255, ${alpha})`;
                    ctx.lineWidth = 0.5;
                    ctx.beginPath();
                    ctx.moveTo(p.x, p.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                }
            }
        });

        requestAnimationFrame(animate);
    }

    window.addEventListener('resize', () => {
        resize();
        init();
    });
    init();
    animate();
}

export function initAiPathway(): void {
    const steps = document.querySelectorAll('.pathway-step');
    if (steps.length === 0) return;

    gsap.from(steps, {
        opacity: 0,
        x: 50,
        stagger: 0.3,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
            trigger: '.pathway-diagram',
            start: 'top 80%',
        }
    });

    // Add glowing pulse to nodes sequentially
    const nodes = document.querySelectorAll('.pathway-step__node');
    const tl = gsap.timeline({ repeat: -1 });
    nodes.forEach((node) => {
        tl.to(node, { boxShadow: '0 0 30px rgba(0, 242, 255, 0.8)', duration: 0.5 })
          .to(node, { boxShadow: '0 0 10px rgba(0, 242, 255, 0.3)', duration: 0.5 });
    });
}
